import { render } from "./tender_table.vue?vue&type=template&id=135e8106"
import script from "./tender_table.vue?vue&type=script&lang=js"
export * from "./tender_table.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/tenders/list/tender_table.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "135e8106"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('135e8106', __exports__)) {
    console.log('reload')
    api.reload('135e8106', __exports__)
  }
  
  module.hot.accept("./tender_table.vue?vue&type=template&id=135e8106", () => {
    console.log('re-render')
    api.rerender('135e8106', render)
  })

}


export default __exports__